import { RxCollectionCreator } from 'rxdb';

export const SiteSpecialistSchema: RxCollectionCreator = {
	schema: {
		title: 'Site Specialist schema',
		description: 'Site Specialist schema',
		version: 0,
		primaryKey: 'sfid',
		type: 'object',
		properties: {
			sfid: {
				type: 'string',
				maxLength: 250,
			},
			mh2code_c: { type: 'string' },
			mh2name_c: { type: 'string' },
			phone_number_c: { type: 'string' },
		},
		required: ['sfid'],
	},
};
